import { Menu, Search } from 'lucide-react';
import { AvatarMenu } from './avatar-menu';
import { NotificationBell } from './notification-bell';
import { TimerPill } from './timer-pill';
import { useMe } from '@/lib/auth';

type TopbarProps = {
  onMenuClick: () => void;
};

/** Admin topbar: global search (⌘K), running-timer pill, account menu. */
export function Topbar({ onMenuClick }: TopbarProps) {
  const me = useMe();

  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b border-[var(--color-sidebar-border)] bg-[var(--color-sidebar)] text-[var(--color-sidebar-foreground)] px-3 sm:gap-3 sm:px-4">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Open navigation"
        className="inline-flex size-9 shrink-0 items-center justify-center rounded-md text-[var(--color-sidebar-muted-foreground)] hover:bg-[var(--color-sidebar-accent)] hover:text-[var(--color-sidebar-foreground)] md:hidden"
      >
        <Menu className="size-5" />
      </button>
      <button
        type="button"
        onClick={() => window.dispatchEvent(new KeyboardEvent('keydown', { key: 'k', metaKey: true }))}
        aria-label="Search"
        className="flex h-9 max-w-md flex-1 items-center gap-2 rounded-md border border-[var(--color-sidebar-border)] bg-[var(--color-sidebar-accent)] px-3 text-sm text-[var(--color-sidebar-muted-foreground)] transition-colors hover:bg-[var(--color-sidebar-border)]"
      >
        <Search className="size-4 shrink-0" />
        <span className="truncate">
          <span className="hidden sm:inline">Search clients, contacts, timeline…</span>
          <span className="sm:hidden">Search…</span>
        </span>
        <span className="ml-auto hidden rounded border border-[var(--color-sidebar-border)] bg-[var(--color-sidebar)] px-1.5 py-0.5 text-[10px] font-medium text-[var(--color-sidebar-muted-foreground)] sm:inline">
          ⌘K
        </span>
      </button>
      <div className="ml-auto flex items-center gap-2">
        <TimerPill />
        <NotificationBell />
        {me.data ? (
          <AvatarMenu name={me.data.name} avatarUrl={me.data.avatar_thumb_url} showSettings />
        ) : null}
      </div>
    </header>
  );
}
